/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Dispose a Bootstrap Tooltip (or Popover, which extends it) without leaving a
 * fade callback behind. Bootstrap queues its show/hide callback on
 * `transitionend` with a setTimeout fallback; if dispose() runs mid-fade, that
 * late callback throws in `_isWithActiveTrigger` (Object.values of null).
 * Dispatching transitionend first runs the callback while the instance state is
 * still valid.
 *
 * @param {import('bootstrap').Tooltip|null|undefined} instance
 */
export function disposeTooltip(instance) {
    if (!instance) {
        return
    }

    instance.tip?.dispatchEvent(new Event('transitionend'))
    instance.dispose()
}
